// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Product_card__2aqHQ {
    padding: 10px; 
    transition: transform 0.2s ease;
    cursor: pointer;
    /* margin-top: 20px; */
    /* margin-bottom: 10px; */
    font-size: 15px ;
}


.Product_card__2aqHQ h5 {
    text-align: center;
    font-size: 15px;
    color: #4f37c5;
    font-weight: bold;
}

.Product_tiltleframe__SU8dh{
    display: inline-block; /* Sử dụng để gạch dưới chỉ nội dung */
    border-bottom: 3px solid black; /* Gạch dưới với độ dày 3px */
    margin-bottom: 20px;
}
.Product_tiltleframe__SU8dh h5{
  color: #555555;  
}

.Product_checkmark__Qfy7- {
    position: absolute; /* Vị trí tuyệt đối */
    top: 10px; /* Khoảng cách từ trên xuống */
    right: 10px; /* Khoảng cách từ bên phải */
    width: 20px; /* Chiều rộng */
    height: 20px; /* Chiều cao */
    background-color: white; /* Màu nền */
    border-radius: 50%; /* Bo tròn thành hình tròn */
    display: flex; /* Sử dụng flexbox để căn giữa */
    align-items: center; /* Căn giữa theo chiều dọc */
    justify-content: center; /* Căn giữa theo chiều ngang */
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Đổ bóng */
}

.Product_cardBill__wncqL
{
    padding: 10px; 
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); 
    transition: transform 0.2s ease; /* Thiếu 's' cho thời gian */
    cursor: pointer; /* Không cần dấu nháy đơn */
    margin-top: 20px;
    margin-bottom: 20px;
    width: 300px;
    margin-left: 50px;
}
.Product_cardBill__wncqL h5 {
    font-size: 22px; /* Kích thước chữ */
    color: #4f37c5; /* Màu chữ */
    margin-top: 10px; /* Khoảng cách phía trên */
    margin-bottom: 10px; /* Khoảng cách phía dưới */
    font-weight: bold; /* Độ đậm của chữ */
    font-family: 'Playfair Display', serif; /* Chỉnh sửa font-family */
}



.Product_actioncontainer__Xj7g6 {
    display: flex;                      
    justify-content: center;            
    margin-top: 20px;                  
}

.Product_createbuttoncontainer__WsU8e {
    background-color: #d8f9d8;         
    padding: 15px;                      
    border-radius: 15px;             
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); 
}

.Product_createbutton__OTHdw {
    background-color: #66bb6a;         
    color: white;                       
    border: none;                      
    border-radius: 20px;               
    padding: 10px 20px;                
    font-size: 16px;                    
    cursor: pointer;                    
    transition: background-color 0.3s;  
}

.Product_createbutton__OTHdw:hover {
    background-color: #57a957;          
}

.Product_linespacing__M739v tr td {
    
    padding: 20px; /* Khoảng cách giữa nội dung trong ô và viền */
}
.Product_section__d5pO8
{
    margin-top: 20px;
    /* margin-bottom: 40px; */
    margin-left: -20px;
}


.Product_tablecontainer__TfxSJ {
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  
  .Product_customtable__g-o\\+g {
    width: 100%;
    border-collapse: collapse;
    background: linear-gradient(90deg, #f8f9fa, #ffffff);
    font-family: 'Arial', sans-serif;
  }
  
  .Product_customtable__g-o\\+g thead {
    background: #007bff;
    color: #ffffff;
    font-size: 14px;
    font-weight: bold;
  }
  
  .Product_customtable__g-o\\+g thead th {
    padding: 15px;
    text-transform: uppercase;
  }
  
  .Product_custom-table__0sIal tbody tr {
    transition: all 0.3s ease;
  }
  
  .Product_custom-table__0sIal tbody tr:hover {
    background-color: #f0f8ff;
    transform: scale(1.02);
  }
  
  .Product_custom-table__0sIal tbody tr.Product_row-selected__z-860 {
    background-color: #e0f7fa;
    border-left: 5px solid #007bff;
  }
  
  .Product_custom-table__0sIal td {
    padding: 12px 15px;
    color: #333;
    font-size: 13px;
  }
  
  .Product_action-icon__YGw8G {
    font-size: 18px;
    color: #007bff;
  }
  
  .Product_custom-table__0sIal td:last-child {
    text-align: center;
  }
  
  .Product_section__d5pO8 {
    padding: 20px;
}

.Product_category__081Hn {
    margin-bottom: 15px;
}


.Product_label__RVSVe {
    font-weight: bold;
    margin-bottom: 10px;
    font-size: 14px;
}

.Product_options__AKokr {
    display: flex;
    gap: 30px;
    flex-wrap: wrap;
}

.Product_optionBtn__PwiRa {
    border: none;
    background-color: #f0f3f6;
    color: #555;
    padding: 8px 12px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 13px;
    transition: all 0.2s ease-in-out;
}

.Product_optionBtn__PwiRa.Product_active__fplk6 {
    background-color: #dceaf8;
    border: 1px solid #0069ff;
    color: #0069ff;
}

/* .optionBtn:hover {
    background-color: #e2f5f0;
} */
.Product_optionsinput__XAyri
{
  /* margin-right: 30px; */
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
}`, "",{"version":3,"sources":["webpack://./src/css/Product.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,+BAA+B;IAC/B,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;AACpB;;;AAGA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,qBAAqB,EAAE,sCAAsC;IAC7D,8BAA8B,EAAE,6BAA6B;IAC7D,mBAAmB;AACvB;AACA;EACE,cAAc;AAChB;;AAEA;IACI,kBAAkB,EAAE,qBAAqB;IACzC,SAAS,EAAE,8BAA8B;IACzC,WAAW,EAAE,4BAA4B;IACzC,WAAW,EAAE,eAAe;IAC5B,YAAY,EAAE,cAAc;IAC5B,uBAAuB,EAAE,YAAY;IACrC,kBAAkB,EAAE,4BAA4B;IAChD,aAAa,EAAE,gCAAgC;IAC/C,mBAAmB,EAAE,4BAA4B;IACjD,uBAAuB,EAAE,8BAA8B;IACvD,wCAAwC,EAAE,YAAY;AAC1D;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,+BAA+B,EAAE,4BAA4B;IAC7D,eAAe,EAAE,2BAA2B;IAC5C,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,eAAe,EAAE,mBAAmB;IACpC,cAAc,EAAE,YAAY;IAC5B,gBAAgB,EAAE,0BAA0B;IAC5C,mBAAmB,EAAE,0BAA0B;IAC/C,iBAAiB,EAAE,mBAAmB;IACtC,sCAAsC,EAAE,0BAA0B;AACtE;;;;AAIA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,aAAa,EAAE,8CAA8C;AACjE;AACA;;IAEI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;AACtB;;;AAGA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,wCAAwC;EAC1C;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,oDAAoD;IACpD,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;IACzB,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;;GAEG;AACH;;EAEE,wBAAwB;EACxB,aAAa;EACb,SAAS;EACT,eAAe;AACjB","sourcesContent":[".card {\n    padding: 10px; \n    transition: transform 0.2s ease;\n    cursor: pointer;\n    /* margin-top: 20px; */\n    /* margin-bottom: 10px; */\n    font-size: 15px ;\n}\n\n\n.card h5 {\n    text-align: center;\n    font-size: 15px;\n    color: #4f37c5;\n    font-weight: bold;\n}\n\n.tiltleframe{\n    display: inline-block; /* Sử dụng để gạch dưới chỉ nội dung */\n    border-bottom: 3px solid black; /* Gạch dưới với độ dày 3px */\n    margin-bottom: 20px;\n}\n.tiltleframe h5{\n  color: #555555;  \n}\n\n.checkmark {\n    position: absolute; /* Vị trí tuyệt đối */\n    top: 10px; /* Khoảng cách từ trên xuống */\n    right: 10px; /* Khoảng cách từ bên phải */\n    width: 20px; /* Chiều rộng */\n    height: 20px; /* Chiều cao */\n    background-color: white; /* Màu nền */\n    border-radius: 50%; /* Bo tròn thành hình tròn */\n    display: flex; /* Sử dụng flexbox để căn giữa */\n    align-items: center; /* Căn giữa theo chiều dọc */\n    justify-content: center; /* Căn giữa theo chiều ngang */\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Đổ bóng */\n}\n\n.cardBill\n{\n    padding: 10px; \n    border-radius: 10px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); \n    transition: transform 0.2s ease; /* Thiếu 's' cho thời gian */\n    cursor: pointer; /* Không cần dấu nháy đơn */\n    margin-top: 20px;\n    margin-bottom: 20px;\n    width: 300px;\n    margin-left: 50px;\n}\n.cardBill h5 {\n    font-size: 22px; /* Kích thước chữ */\n    color: #4f37c5; /* Màu chữ */\n    margin-top: 10px; /* Khoảng cách phía trên */\n    margin-bottom: 10px; /* Khoảng cách phía dưới */\n    font-weight: bold; /* Độ đậm của chữ */\n    font-family: 'Playfair Display', serif; /* Chỉnh sửa font-family */\n}\n\n\n\n.actioncontainer {\n    display: flex;                      \n    justify-content: center;            \n    margin-top: 20px;                  \n}\n\n.createbuttoncontainer {\n    background-color: #d8f9d8;         \n    padding: 15px;                      \n    border-radius: 15px;             \n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); \n}\n\n.createbutton {\n    background-color: #66bb6a;         \n    color: white;                       \n    border: none;                      \n    border-radius: 20px;               \n    padding: 10px 20px;                \n    font-size: 16px;                    \n    cursor: pointer;                    \n    transition: background-color 0.3s;  \n}\n\n.createbutton:hover {\n    background-color: #57a957;          \n}\n\n.linespacing tr td {\n    \n    padding: 20px; /* Khoảng cách giữa nội dung trong ô và viền */\n}\n.section\n{\n    margin-top: 20px;\n    /* margin-bottom: 40px; */\n    margin-left: -20px;\n}\n\n\n.tablecontainer {\n    border-radius: 10px;\n    overflow: hidden;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  }\n  \n  .customtable {\n    width: 100%;\n    border-collapse: collapse;\n    background: linear-gradient(90deg, #f8f9fa, #ffffff);\n    font-family: 'Arial', sans-serif;\n  }\n  \n  .customtable thead {\n    background: #007bff;\n    color: #ffffff;\n    font-size: 14px;\n    font-weight: bold;\n  }\n  \n  .customtable thead th {\n    padding: 15px;\n    text-transform: uppercase;\n  }\n  \n  .custom-table tbody tr {\n    transition: all 0.3s ease;\n  }\n  \n  .custom-table tbody tr:hover {\n    background-color: #f0f8ff;\n    transform: scale(1.02);\n  }\n  \n  .custom-table tbody tr.row-selected {\n    background-color: #e0f7fa;\n    border-left: 5px solid #007bff;\n  }\n  \n  .custom-table td {\n    padding: 12px 15px;\n    color: #333;\n    font-size: 13px;\n  }\n  \n  .action-icon {\n    font-size: 18px;\n    color: #007bff;\n  }\n  \n  .custom-table td:last-child {\n    text-align: center;\n  }\n  \n  .section {\n    padding: 20px;\n}\n\n.category {\n    margin-bottom: 15px;\n}\n\n\n.label {\n    font-weight: bold;\n    margin-bottom: 10px;\n    font-size: 14px;\n}\n\n.options {\n    display: flex;\n    gap: 30px;\n    flex-wrap: wrap;\n}\n\n.optionBtn {\n    border: none;\n    background-color: #f0f3f6;\n    color: #555;\n    padding: 8px 12px;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 13px;\n    transition: all 0.2s ease-in-out;\n}\n\n.optionBtn.active {\n    background-color: #dceaf8;\n    border: 1px solid #0069ff;\n    color: #0069ff;\n}\n\n/* .optionBtn:hover {\n    background-color: #e2f5f0;\n} */\n.optionsinput\n{\n  /* margin-right: 30px; */\n  display: flex;\n  gap: 30px;\n  flex-wrap: wrap;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `Product_card__2aqHQ`,
	"tiltleframe": `Product_tiltleframe__SU8dh`,
	"checkmark": `Product_checkmark__Qfy7-`,
	"cardBill": `Product_cardBill__wncqL`,
	"actioncontainer": `Product_actioncontainer__Xj7g6`,
	"createbuttoncontainer": `Product_createbuttoncontainer__WsU8e`,
	"createbutton": `Product_createbutton__OTHdw`,
	"linespacing": `Product_linespacing__M739v`,
	"section": `Product_section__d5pO8`,
	"tablecontainer": `Product_tablecontainer__TfxSJ`,
	"customtable": `Product_customtable__g-o+g`,
	"custom-table": `Product_custom-table__0sIal`,
	"row-selected": `Product_row-selected__z-860`,
	"action-icon": `Product_action-icon__YGw8G`,
	"category": `Product_category__081Hn`,
	"label": `Product_label__RVSVe`,
	"options": `Product_options__AKokr`,
	"optionBtn": `Product_optionBtn__PwiRa`,
	"active": `Product_active__fplk6`,
	"optionsinput": `Product_optionsinput__XAyri`
};
export default ___CSS_LOADER_EXPORT___;
